export default {"src":"/_next/static/media/ohm.1b779b45.svg","height":227,"width":227,"blurWidth":0,"blurHeight":0};